import {
    AsAllowed,
    AsDisabled,
    LimitationProps
} from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';
import i18next from 'i18next';

export const forbidTwoSchedulerBlocks = ({
    targetFlow,
    sourceForMessage
}: LimitationProps<'targetFlow', 'sourceForMessage'>) => {
    const t = i18next.getFixedT(null, 'builder', '');

    if (targetFlow.hasScheduleBlock) {
        const reason =
            sourceForMessage === 'reuse'
                ? t('creation_limitation_dialog.scheduler_already_exists')
                : t('create_block.disable_create_another_scheduling_block');

        return AsDisabled(reason);
    }

    return AsAllowed;
};
